import {UIMainScreenModule} from './UIMainScreen/UIMainScreenModule';
import {UIRubyAutoplayOptionsModule} from './uiRubyAutoplayOptions/UIRubyAutoplayOptionsModule';
import {SpinButtonModule} from './SpinButton/SpinButtonModule';
import {JurisdictionZoneModule} from './JurisdictionZone/JurisdictionZoneModule';

export const modules = [
    UIMainScreenModule,
    UIRubyAutoplayOptionsModule,
    SpinButtonModule,
    JurisdictionZoneModule,
];